import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';

import { AppTheme } from '../../../../styles/AppTheme';

export function AutomationAddActionMenu(props) {
  const open = !!props.open;
  const pos = props.anchorPosition || { top: 0, left: 0 };
  return (
    <Popover
      open={open}
      onClose={props.onClose}
      anchorReference='anchorPosition'
      anchorPosition={pos}
      getContentAnchorEl={null}
      elevation={0}
      marginThreshold={12}
      PaperProps={{
        role: 'dialog',
        'aria-label': 'Add action',
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
        },
      }}
      classes={{ paper: css(Styles.popover) }}
    >
      <div className={css(Styles.inner)}>
        <MenuItem onClick={props.onSelect} className={css(Styles.menuItem)}>
          <i className={'material-icons-outlined ' + css(Styles.menuIcon)}>bolt</i>
          <span>Add action</span>
        </MenuItem>
      </div>
    </Popover>
  );
}

const Styles = StyleSheet.create({
  popover: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    overflow: 'visible',
  },
  inner: {
    padding: 4,
    minWidth: 160,
    boxShadow: '3px 6px 43px rgba(0, 0, 0, 0.05)',
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: 12,
    backgroundColor: AppTheme.secondaryBg,
  },
  menuItem: {
    fontSize: 13,
    color: '#6E84A3',
    padding: '6px 10px',
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  menuIcon: {
    fontSize: 18,
    color: '#6B7280',
  },
});
